import * as Types from '../../../../../../graphql-types'

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'
export type AddOnMenuGroupsQueryVariables = Types.Exact<{
  outletId: Types.Scalars['ID']
  fulfilmentMethods:
    | Array<Types.MenuItemGroupFulfillmentMethod>
    | Types.MenuItemGroupFulfillmentMethod
  subTotal: Types.Scalars['Int']
  endOfPrep?: Types.InputMaybe<Types.Scalars['DateTime']>
}>

export type AddOnMenuGroupsQuery = {
  menuItemGroupsForOutlet: Array<{
    __typename: 'OutletMenuItemGroup'
    id: string
    name: string
    description: string | null
    addOnItemsMaxQuantity: number | null
    addOnItemsMenuMinimumBasketTotal: number | null
    showMenuThumbnails: boolean | null
    outletMenuItems: Array<{
      __typename: 'OutletMenuItem'
      id: string
      menuItemId: string
      name: string
      maxPurchaseQuantity: number | null
      price: number
      addOnMaxPrice: number | null
      minimumPurchasePrice: number | null
      isVegetarian: boolean | null
      isVegan: boolean | null
      isGlutenFree: boolean | null
      isDairyFree: boolean | null
      isKeto: boolean
      spiceLevel: number
      ageRestricted: boolean | null
      image: string | null
      description: string | null
      parentMenu: { __typename: 'MenuItemGroup'; id: string; name: string }
      outlet: {
        __typename: 'Outlet'
        id: string
        restaurant: {
          __typename: 'Restaurant'
          id: string
          addOnItemsUseHighestQualifyingMenuGroup: boolean | null
        }
      } | null
    }>
  }>
}

export const AddOnMenuGroupsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AddOnMenuGroups' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'outletId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'fulfilmentMethods' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: {
                    kind: 'Name',
                    value: 'MenuItemGroupFulfillmentMethod',
                  },
                },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'subTotal' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'endOfPrep' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'DateTime' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'menuItemGroupsForOutlet' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'outletId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'outletId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'fulfillmentMethods' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'fulfilmentMethods' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'subTotal' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'subTotal' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'endOfPrep' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'endOfPrep' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'addOnItemsMenu' },
                value: { kind: 'BooleanValue', value: true },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'addOnItemsMaxQuantity' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'addOnItemsMenuMinimumBasketTotal',
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'showMenuThumbnails' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'outletMenuItems' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'menuItemId' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'maxPurchaseQuantity' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'price' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'addOnMaxPrice' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'minimumPurchasePrice' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isVegetarian' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isVegan' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isGlutenFree' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isDairyFree' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isKeto' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'spiceLevel' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ageRestricted' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'image' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'description' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'parentMenu' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'outlet' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'restaurant' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value:
                                        'addOnItemsUseHighestQualifyingMenuGroup',
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AddOnMenuGroupsQuery,
  AddOnMenuGroupsQueryVariables
>
